import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import useIsInView from 'utils/hooks/useIsInView';

const AnimateStyled = styled.div`
	opacity: 0;
	transition: opacity 1s cubic-bezier(0.27, 0.29, 0.46, 0.96),
		transform 1s cubic-bezier(0.27, 0.29, 0.46, 0.96);
	transform: translateY(60px);
	display: block;
	${props =>
		props.inView &&
		`
		transform: translateY(0);
		opacity: 1;
	`};
	transition-delay: ${props => props.delay}ms;
`;

const Animate = ({ children, delay, animation, on, animateOnInView }) => {
	const [ref, inView] = useIsInView(100);
	const trigger = animateOnInView ? inView : on;
	return (
		<AnimateStyled delay={delay} animation={animation} inView={trigger} ref={ref}>
			{children}
		</AnimateStyled>
	);
};

Animate.propTypes = {
	delay: PropTypes.number,
	on: PropTypes.any,
	animation: PropTypes.string,
	animateOnInView: PropTypes.bool
};

Animate.defaultProps = {
	delay: 0,
	animation: 'slideUp',
	animateOnInView: false
};

export default Animate;
